import Storyblok from '@/src/app/utils/storyblok';

const requestStoryBlok = async ({query, slug}) => {
  return await Storyblok.get(`cdn/stories/${slug ?? ''}`, query);
};

export default requestStoryBlok;
